import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ARadioComponent } from './a-radio/a-radio.component';
import { ACheckboxComponent } from './a-checkbox/a-checkbox.component';
import { AComboBoxComponent } from './a-combo-box/a-combo-box.component';
import { AInputComponent } from './a-input/a-input.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ATextAreaComponent } from './a-text-area/a-text-area.component';


const components = [
    ACheckboxComponent,
    AComboBoxComponent,
    ARadioComponent,
    AInputComponent,
    ATextAreaComponent
];


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgSelectModule
    ],
    declarations: components,
    exports: components
})
export class UiFormsModule {
}
